<template>
  <div class="lottery" :class="cssType">
    <div class="lottery-title" :class="locale"></div>
    <div class="lottery-desc">
      <div class="p" v-for="(item, index) in $t('sf.lottery.desc').split('\n')" :key="index">{{ item }}</div>
    </div>
    <div class="lottery-times">
      <div class="p" v-for="(item, index) in $t('sf.lottery.times').split('\n')" :key="index">{{ item }}</div>
    </div>
    <div class="operate">
      <SfButton type="blue" @click="goRecharge">{{ $t('cny.goRecharge') }}</SfButton>
      <SfButton type="yellow" @click="handleShowRecord">{{ $t('cny.record') }}</SfButton>
    </div>
    <div class="lottery-wheel-wrapper">
      <Wheel ref="wheelRef" />
    </div>
    <div class="lottery-wrapper">
      <div class="role">
        <img class="role-p role-p-1" src="~@/assets/imgs/act/sf/role-p-1.png" alt="prop">
        <img class="role-p role-p-2" src="~@/assets/imgs/act/sf/role-p-2.png" alt="prop">
        <img class="role-p role-p-3" src="~@/assets/imgs/act/sf/role-p-3.png" alt="prop">
        <img class="role-p role-p-4" src="~@/assets/imgs/act/sf/role-p-4.png" alt="prop">
      </div>
      <div class="remaining-times" :class="locale">
        {{ $t('sf.lottery.remainingTimes') }}：{{ state.remainingTimes >= 0 ? state.remainingTimes : 0 }}
        <div class="skip-animation" @click="state.skipAnimation = !state.skipAnimation">
          <div class="checkbox">
            <div class="checkbox-inner" :class="{ 'checked': state.skipAnimation }"></div>
          </div>
          {{ $t('sf.lottery.skipAnimation') }}
        </div>
      </div>
      <div class="lottery-operation">
        <SfButton type="red" :disabled="store.state.cpUserInfo.token && state.remainingTimes <= 0" @click="handleLotteryOnce">{{ $t('sf.lotteryOnce') }}</SfButton>
        <SfButton type="red" :disabled="store.state.cpUserInfo.token && state.remainingTimes <= 0" @click="handleLotteryOneKey">{{ $t('sf.lotteryOneKey') }}</SfButton>
      </div>
    </div>
    <!-- <FireworkCanvas2
      ref="fireworkCanvas2Ref"
      :isVisible="state.isVisible2"
      @animationComplete="handleAnimationComplete"
    /> -->
  </div>
</template>
<script setup>
/* eslint-disable */
import { reactive, ref, inject, computed } from 'vue'
import FireworkCanvas2 from '../../components/FireworkCanvas/index2.vue'
import Wheel from './components/wheel'
import { isMobile } from '@/utils'
import { useI18n } from 'vue-i18n'
import SfButton from '../SfButton'
import { useStore } from 'vuex'
import { toastService } from '@/utils/toastService'
import SfActApi from '@/config/sfActApi'
const store = useStore()
const globalConfig = inject('globalConfig')
const toggleLotteryRecordDialog = inject('toggleLotteryRecordDialog')
const { locale, t } = useI18n()
const cssType = isMobile ? 'mobile' : 'pc'
const wheelRef = ref(null)
const payUrl = computed(() => {
  return process.env.VUE_APP_HISTORY_URL + locale.value
})
const fireworkCanvas2Ref = ref(null)
const state = reactive({
  remainingTimes: computed(() => globalConfig.totalLotteryCount - globalConfig.usedLotteryCount),
  skipAnimation: false,
  isVisible2: false
})
const goRecharge = () => {
  window.open(payUrl.value, '_blank')
}
const handleLotteryOnce = () => {
  if (!store.state.cpUserInfo.token) {
    toastService.show(t('payment.validateUser.noUserText'))
    return
  }
  if (state.remainingTimes <= 0) return
  wheelRef.value.doLottery(state.skipAnimation)
  // state.isVisible2 = true
  // fireworkCanvas2Ref.value?.playSmallFirework()
}
const handleLotteryOneKey = () => {
  if (!store.state.cpUserInfo.token) {
    toastService.show(t('payment.validateUser.noUserText'))
    return
  }
  if (state.remainingTimes <= 0) return
  wheelRef.value.doLotteryOneKey(state.skipAnimation)
  // state.isVisible2 = true
  // fireworkCanvas2Ref.value?.playLargeFirework()
}

const handleAnimationComplete = () => {
  state.isVisible2 = false
}

const getLotteryRecord = async () => {
  
  const res = await SfActApi.getLotteryRecord()
  console.log('getLotteryRecord res', res)
  return res.lotteryRecordList
}

const handleShowRecord = async () => {
  if (!store.state.cpUserInfo.token) {
    toastService.show(t('payment.validateUser.noUserText'))
    return
  }
  
  const lotteryRecordList = await getLotteryRecord()
  const result = []
  lotteryRecordList.forEach(item => {
    const displayItem = globalConfig.displayList.find(displayItem => displayItem.lotteryRewardCode === item.lotteryRewardCode)
    result.push({
      ...displayItem,
      time: item.createTime,
    })
  })
  console.log('result', result)
  // const list = JSON.parse(JSON.stringify(LOTTERY_WHEEL_LIST))
  // list.forEach(item => {
  //   item.time = new Date().toLocaleString()
  // })
  toggleLotteryRecordDialog(true, { list: result }, () => {})
}

</script>

<style src="./pc_style.less" lang="less" scoped></style>
<style src="./mobile_style.less" lang="less" scoped></style>

